import React from 'react'
import { View } from 'react-native'
import { CopilotStep, walkthroughable } from 'react-native-copilot'
import { getAnchoredStepByTargetId, getAnchoredStepOrder } from './steps'
import { useNoraHomeWalkthroughContext } from './NoraHomeWalkthroughContext'
import { NoraHomeWalkthroughTargetId, NoraHomeWalkthroughTargetProps } from './types'

const CopilotView = walkthroughable(View)

export const NoraHomeWalkthroughTarget = ({
  targetId,
  accessibilityLabel,
  children,
  style,
}: NoraHomeWalkthroughTargetProps) => {
  const context = useNoraHomeWalkthroughContext()
  const step = getAnchoredStepByTargetId(targetId)

  if (!context || !step) {
    return (
      <View accessibilityLabel={accessibilityLabel} collapsable={false} style={style}>
        {children}
      </View>
    )
  }

  return (
    <CopilotStep
      name={targetId}
      order={getAnchoredStepOrder(targetId)}
      text={step.body}
      active
      scrollable={targetId !== NoraHomeWalkthroughTargetId.Settings}
    >
      <CopilotView accessibilityLabel={accessibilityLabel} collapsable={false} style={style}>
        {children}
      </CopilotView>
    </CopilotStep>
  )
}
